module.exports = "../../../../platform/assets/pageMainIcon/simple_danjuweihulei1.svg";